<template>
  <div class="file-management">
    <div class="fileManagement-header" ref="fileManagement-header">
      <div class="top">
        <ul class="breadcrumb">
          <!-- <li @click="handleAllFile">全部文件</li> -->
          <li v-for="(item, index) of breadcrumb" :key="item.id" @click="handleBreadcrumb(item.id, index)" :class="{ 'last-bread': index === breadcrumb.length - 1 || breadcrumb.length === 1 }">
            <p>{{ item.name }}</p>
            <span v-if="index !== breadcrumb.length - 1" style="margin-right: 2px;">/</span>
          </li>
          <!-- <span class="breadcrumb-all" v-if="breadcrumb.length === 1">{{ foldeCount + fileCount }}</span> -->
        </ul>
        <div class="btn-right">
          <FilterBox></FilterBox>
        </div>
      </div>
      <div class="search-wrap">
        <div class="info-btn-box">
          <div class="info-btn" >
            <UploadOss @onUploadProgress="onProgress">
              <wf-button size="small">
                <p class="upload-icon-box"><img class="upload-icon" src="./img/icon_upload.svg" alt="" />上传文件</p>
              </wf-button>
            </UploadOss>
          </div>
          <div class="operate-wrap" v-if="selectCount > 0">
            <wf-button plain size="small" @click="handleDownload" :disabled="selectCount === 0">下载</wf-button>
            <wf-button plain size="small" class="warn" type="danger" @click="handleDel">删除</wf-button>
          </div>
        </div>
        <div class="search-wrap-right">
          <div class="num-wrap">
            <p class="total">
              <span v-if="selectCount > 0">已选{{ selectCount }}个文件、</span>
              <span v-if="foldeCount > 0 || fileCount > 0">共</span>
              <span v-if="foldeCount > 0">{{ foldeCount }}个文件夹</span>
              <span>{{ foldeCount > 0 && fileCount > 0 ? "、" : "" }}</span>
              <span v-if="fileCount > 0">{{ fileCount }}个文件</span>
            </p>
          </div>
          <el-tooltip class="tooltip" effect="dark" content="上传文件不能超过200M" placement="bottom">
            <i class="icon iconfont iconicon_help_nor"></i>
          </el-tooltip>
        </div>
      </div>
    </div>
    <div class="file-wrap" ref="file-wrap" v-infinite-scroll="load" infinite-scroll-delay="500" infinite-scroll-distance="0" v-if="modelView === 'chart'">
      <div class="file-item-wrap">
        <Folde ref="folde" v-for="item in fileList" :key="item.id" :dataset="item" :check="check" :checked="item.checked" @change="foleSelectChange" @click="handleClickFolder" @openDetail="previewFile" :toolObj="toolObj" @updateInit="handleInit"></Folde>
        <div class="file-item-uploadArr-wrap" v-if="uploadArr.length">
          <div class="file-item-uploadArr" v-for="item in uploadArr" :key="item.name + 'isupload'" >
            <Folde v-if="item.percentage < 100" :dataset="item" :loading="item.percentage" isRedy @stopUpload="handleCancelUpload(item)"></Folde>
          </div>
        </div>
      </div>
      <nothing :config="{}" v-show="fileList.length === 0 && uploadArr.length === 0"></nothing>
      <div style="height: 100px" v-loading="loading"></div>
    </div>
    <Table
      v-else
      ref="table"
      :ruleForm="apiData"
      :t="allFileList"
      :tableData="tableData"
      :loading="loading"
      :finish="infiniteLock"
      :isSelect="true"
      :sall="sall"
      :hasData="hasData"
      :toolObj="toolObj"
      :tableHead="tableHead"
      @init="init"
      @load="load"
      @openDetail="previewFile"
      @change="foleSelectChange"
      @selectAll="handleSelectAll"
      :border="false"
    >
      <template slot="file_cabinet_name" slot-scope="scope">
        <div class="can-view" :class="{ 'is-loading': scope.row.loading }" @click="nameCheck(scope.row)">
          <img :src="scope.row.type === 1 ? (scope.row.number_of_child_files ? 'image/file/img_folde.png' : 'image/file/img_empty_folde.png') : getFileTypeUrl($$(scope.row, 'attachment_type') || scope.row.type)" alt="" />
          <div class="tip-in">
            <toolTip class="title-in-text" :title="getFilName(scope.row)"
              ><span>{{ getFilName(scope.row) }}</span></toolTip
            >
          </div>
        </div>
      </template>
      <template slot="changeTime" slot-scope="scope">
        {{ scope.row.update_time ? scope.row.update_time.replace(/\-/g, "/").split('.')[0] : "" }}
      </template>
    </Table>
    <!-- 新建文件夹弹窗 -->
    <el-dialog title="新建文件夹" :visible.sync="dialogVisible" width="422px" :close-on-click-modal="false" :show-close="false" custom-class="file-management-dialog" append-to-body>
      <el-input ref="newFolderInput" type="textarea" maxlength="20" v-model="newFolderName" placeholder="请输入名称" @keydown.native="newFolderFnKeydown($event)"></el-input>
      <div class="dialog-footer" slot="footer">
        <span class="cancel text-btn-active" @click="dialogVisible = false" style="margin-right: 24px;">取消</span>
        <wf-button type="primary" :disabled="!newFolderName" @click="newFolderFn">确 定</wf-button>
      </div>
    </el-dialog>

    <!-- 文件树弹窗 -->
    <el-dialog v-if="dialogVisible2" title="选择移动位置" :visible.sync="dialogVisible2" width="590px" :close-on-click-modal="false" :show-close="false" custom-class="file-management-dialog file-management-dialog-tree" append-to-body>
      <el-tree ref="tree" :data="treeData" :props="dataTreeProps" :load="loadNode" @node-click="handleNodeChos" highlight-current :expand-on-click-node="false" node-key="id" :default-expanded-keys="[fileTreesId]" lazy> </el-tree>
      <div class="dialog-footer" slot="footer">
        <span class="cancel text-btn-active" @click="dialogVisible2 = false" style="margin-right: 24px;">取消</span>
        <wf-button type="primary" @click="moveFn">确 定</wf-button>
      </div>
    </el-dialog>
    <RestNameDialog v-model="restNameShow" :dataset="checkCell" @updateInit="handleInit"></RestNameDialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import File from "@/components/file";
import UploadOss from "@/components/uploadOss";
//api
import fileApi from "@/services/api/fileManagement";
import Folde from "./folde";
import RestNameDialog from "./reastName";
import Table from "./table";
import FilterBox from './filterBox'
import Search from '@/components/taskFilterBox/search'
import SortList from './filterBox/sortList'
import ModCheck from './filterBox/modCheck'
export default {
  components: {
    File,
    UploadOss,
    Folde,
    RestNameDialog,
    Table,
    FilterBox,
    Search,
    SortList,
    ModCheck
  },
  props: {
    fileTreesId: {
      type: Number,
    },
    fileTreesName: {
      type: String,
    },
    fileCreatePermission: {
      //项目文件新建文件夹权限
      type: Boolean,
      default: false,
    },
    cancelUpload: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("template/template", {
      modelView: (state) => state.modelView,
      queryMsg: state => state.queryMsg,
      dataset: state => state.dataset
    }),
    checkedIdList() {
      let ids = this.fileList
        .map((res) => {
          if (res.checked) {
            return res.id;
          }
        })
        .filter((res) => res);
      return ids;
    },
    getFilName() {
      // 获取文件名称
      return (item) => {
        return (item.type === 1 ? item?.folder_name : item?.attachment_name) || item.name || item.attachment_name;
      };
    },
    allFileList() {
      this.tableData = [...this.fileList, ...this.uploadArr];
    },
  },
  watch: {
    fileList: {
      handler() {
        // 监听改变数量
        this.foldeCount = 0;
        this.fileCount = 0;
        this.selectCount = 0;
        this.deletePermission = false;
        this.movePermission = false;
        this.downloadPermission = false;
        this.fileList.forEach((res) => {
          if (res.checked) {
            this.selectCount = this.selectCount + 1;
          }
          if (res.checked && res.type === 1) {
            this.downloadPermission = true;
          }
          if (res.checked) {
            this.deletePermission = true;
          }
          if (res.checked) {
            this.movePermission = true;
          }
          if (res.type === 1) {
            this.foldeCount = this.foldeCount + 1;
          } else if (res.type === 2) {
            this.fileCount = this.fileCount + 1;
          }
        });
        if (this.selectCount > 0) {
          this.isDisabled = false;
          this.sall = this.fileCount === this.selectCount;
          this.check = true;
        } else {
          this.isDisabled = true;
          this.check = false;
          this.sall = false;
        }
      },
      deep: true,
    },
    dialogVisible(val) {
      if (!val) {
        this.newFolderName = "";
      }
    },
    cancelUpload(val) {
      if (val) {
        //离开组件 取消所有上传中的请求
        this.uploadArr.forEach((item) => {
          this.handleCancelUpload(item);
        });
      }
    },
    fileTreesId(val) {
      // console.log(val, 111)
      if (val) {
        this.apiData.pid = val
        this.init()
      }
    },
    queryMsg: {
      handler() {
        this.debounce(this.init, 500)
      },
      deep: true
    }
  },
  data() {
    const _this = this
    return {
      foldeCount: 0,
      fileCount: 0,
      selectCount: 0,
      loading: false,
      sall: false,
      isDisabled: false,
      infiniteLock: false, //无限加载的lock
      selectSort: "修改时间",
      sortList: ["修改时间", "文件名"],
      initLock: false,
      deletePermission: false, //删除权限
      movePermission: false, //移动权限
      downloadPermission: false, //下载权限
      timer: null,
      selectAll: false,
      dialogVisible: false, //新建文件夹弹窗
      newFolderName: "", //新建文件夹名称
      dialogVisible2: false, //文件树弹窗
      restNameShow: false,
      checkCell: {},
      tableData: [],
      hasData: false,
      tableHead: [
        {
          name: "名称",
          key: "file_cabinet_name",
          minWidth: "150%",
        },
        {
          name: "修改时间",
          key: "changeTime",
        },
      ],
      apiData: {
        number: 55,
        page: 1,
        pid: this.fileTreesId,
        keyword: "",
        sort_rule: "update_time_sort",
      },
      operateLock: false,
      sall: false,
      uploading: false,
      uploadArr: [],
      fileList: [],
      total: 0,
      chosTotal: 0,
      breadcrumb: [
        {
          name: "全部文件",
          id: this.fileTreesId,
          createPermission: this.fileCreatePermission,
        },
      ],
      dataTreeProps: {
        label: "folder_name",
        children: "children",
        isLeaf: "isLeaf",
      },
      treeData: [],
      treePage: 1,
      moveId: null,
      check: false,
      toolObj: [
        {
          value: "down",
          label: "下载",
          icon: "iconicon_download",
          permissions: (data) => {
            return true
          },
          fn: (row) => {
            this.handleFileDown([row.id]);
          },
        },
        {
          value: "restname",
          label: "重命名",
          icon: "iconicon_question_minutes_nor",
          permissions: (data) => {
            return true
          },
          fn: (row) => {
            this.handleRename(row);
          },
        },
        {
          value: "move",
          label: "移动",
          icon: "iconicon_move",
          permissions: (data) => {
            return false
          },
          fn: (row) => {
            this.handleMove(row);
          },
        },
        {
          value: "del",
          label: "删除",
          type: "del",
          icon: "iconicon_delete",
          permissions: (data) => {
            return true
          },
          fn: (row) => {
            this.handleFileDelete([{ id: row.id, type: row.type }]);
          },
        },
      ],
    };
  },
  created() {
    this.init()
  },
  mounted() {},
  beforeDestroy() {
    this.$refs["file-wrap"] ? this.$refs["file-wrap"].removeEventListener("scroll", this.load) : ''
    this.clear_queryMsg()
  },
  methods: {
    ...mapMutations('template/template', ['clear_queryMsg']),
    load() {
      if (this.loading || this.infiniteLock) {
        return;
      }
      this.apiData.page++;
      this.init(true);
    },
    //初始化获取文件列表
    async init(lock) {
      this.loading = true;
      // if (this.initLock) return
      // this.initLock = true
      // this.fileList = [];
      const res = this.filteredAndSortedItems()
      if (res) {
        this.hasData = true;
        if (res.length < 55) {
          // 判断返回数据数量 如若少于20 则无需无限加载
          this.infiniteLock = true;
        } else {
          this.infiniteLock = false;
        }
        this.loading = false;
        if (lock) {
          //进入下拉加载方法
          this.fileList.push(...res);
        } else {
          this.fileList = res;
        }
        this.total = this.fileList.length;
        // this.initLock = false
        // console.log(this.fileList)
      }
    },
    filteredAndSortedItems() {
      return this.dataset.project_attachments
        .filter(item => item.attachment_name.toLowerCase().includes(this.queryMsg.keyword.toLowerCase()))
        .sort((a, b) => {
            let result = 0
            if (this.queryMsg.sort_rule === 'name_sort') {
                result = a.attachment_name.localeCompare(b.attachment_name)
            } else if (this.queryMsg.sort_rule === 'update_time_sort') {
                result = new Date(a.update_time) - new Date(b.update_time)
            }
            return result
        })
    },
    //防抖函数
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(fn, wait);
    },
    valueChange() {
      this.apiData.page = 1;
      this.apiData = {...this.apiData, ...this.queryMsg}
      this.debounce(this.init, 500);
    },
    //面包屑点击
    handleBreadcrumb(id, index) {
      if (id === 1000000) {
        //返回项目文件
        this.$emit("back");
      } else {
        // console.log(index, this.breadcrumb.length)
        if (this.breadcrumb.length === index + 1) {
          //点击最后一项
          return;
        } else {
          this.breadcrumb.splice(index + 1);
          this.fileList = [];
          this.apiData = {
            number: 55,
            page: 1,
            pid: id,
            keyword: "",
          };
          this.init();
        }
      }
    },
    //点击文件夹
    handleClickFolder(item) {
      let id = item.id;
      let name = item.folder_name;
      this.apiData.pid = item.id;
      this.breadcrumb.push({ name, id, createPermission: true });
      // console.log(this.breadcrumb)
      this.fileList = [];
      this.apiData.page = 1;
      this.init();
    },
    //更新
    handleInit() {
      this.apiData.page = 1;
      this.restNameShow = false;
      this.init();
    },
    //切换排序方式
    handleChangeSort(data) {
      this.apiData.sort_rule = data
      this.apiData.page = 1;
      this.init();
    },
    //新建文件夹
    handleNewFolder() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.newFolderInput.focus();
      });
    },
    //输入框回车键
    newFolderFnKeydown(event) {
      if (event.keyCode === 13) {
        this.newFolderFn();
        event.preventDefault(); // 阻止浏览器默认换行操作
        return false;
      }
    },
    async newFolderFn() {
      if (!this.newFolderName) return;

      this.newFolderName = this.newFolderName.trim();
      const _data = {
        pid: this.apiData.pid,
        folder_name: this.newFolderName,
      };
      const res = await fileApi.addFolders(_data);
      if (res) {
        this.dialogVisible = false;
        this.$message({
          message: "新建文件夹成功",
          type: "success",
        });
        this.reset();
        this.apiData.page = 1;
        this.init();
      }
    },
    //全选
    handleSelectAll(data) {
      if (!this.fileList || this.fileList.length === 0) {
        return;
      }
      this.fileList.forEach((res, index) => {
        this.$set(this.fileList[index], "checked", data);
      });
      // this.$refs.table ? this.$refs.table.selectAll() : ''
    },
    //重置行为
    reset() {
      this.sall = false;
      this.selectAll = false;
      this.selctCancel();
    },
    selctCancel() {
      // 取消全选
      if (this.modelView === "chart") {
        for (let key of this.$refs.folde) {
          if (key.checked) {
            key.clearSelection();
          }
        }
      }
      // else {
      //   this.$refs.table.clearSelection();
      // }
    },
    handleCancel() {
      this.reset();
      this.downloadFnFinish();
    },
    downloadFnFinish() {
      this.fileList.forEach((item) => {
        item.downloading = false;
      });
    },
    //批量下载
    handleDownload() {
      if (this.checkedIdList.length <= 0) return;
      if (this.downloadPermission) {
        this.$message({
          message: '文件夹不可下载',
          type: 'warning'
        });
        return
      }
      this.handleFileDown(this.checkedIdList);
      this.reset();
    },
    //下载
    async handleFileDown(arr) {
      this.tis = this.$message({
        showClose: true,
        duration: 0,
        message: "文件准备下载中…",
        type: "warning",
      });
      const res = await fileApi.downFile({ file_trees_id: arr });
      if (res) {
        this.tis.close();
        this.downloadFnFinish();
        // location.href = res[0]
        window.open(res[0]);
        for (let i = 1, len = res.length; i < len; i++) {
          setTimeout(() => {
            // location.href = res[i]
            window.open(res[i]);
          }, 100);
        }
      }
    },
    handleMove(item) {
      this.checkCell = item;
      this.dialogVisible2 = true;
    },
    async moveFn() {
      if (!this.moveId) return;
      let ids = this.fileList
        .map((res) => {
          if (res.checked) {
            return res.id;
          }
        })
        .filter((res) => res);
      const _data = {
        target_file_tree_id: this.moveId,
        file_trees_id: this.selectCount > 0 ? ids : [this.checkCell.id],
      };
      const res = await fileApi.moveFile(_data);
      if (res) {
        this.dialogVisible2 = false;
        this.$message({
          message: "移动成功",
          type: "success",
        });
        this.reset();
        this.apiData.page = 1;
        this.init();
      }
    },
    handleDel() {
      let ids = this.fileList
        .map((res) => {
          if (res.checked) {
            return {
              id: res.id,
              type: res.type,
            };
          }
        })
        .filter((res) => res);
      if (ids.length <= 0) return;
      this.handleFileDelete(ids);
    },
    async handleFileDelete(arr) {
      // console.log(arr)
      const _text = arr.length > 1 ? "所选内容" : arr[0].type === 1 ? "该文件夹" : "该文件";
      await this.$wfAlert('warning',`确定删除${_text}?`, '', '确定')
      let file_trees_id = [];
      for (let i = 0, len = arr.length; i < len; i++) {
        file_trees_id.push(arr[i].id);
      }
      arr.forEach(async res => {
        await this.delMany(res)
      })
      this.$message({
        message: "删除成功",
        type: "success",
      });
      this.reset();
      this.apiData.page = 1;
      this.init();
    },
    delMany(id) {
      let index = this.dataset.project_attachments.findIndex(res => res.id === id)
      this.dataset.project_attachments.splice(index, 1)
      return this.$nextTick()
    },
    loadNode(node, resolve) {
      // console.log(resolve)
      if (node.level === 0) {
        return resolve([{ folder_name: "全部文件", id: this.fileTreesId, isLeaf: false }]);
      } else {
        this.loadDataTreeFn(node).then((res) => {
          // console.log(res)
          resolve(res);
        });
        // resolve(this.loadDataTreeFn(node))
      }
    },
    async loadDataTreeFn(node) {
      const _data = {
        number: 999,
        page: this.treePage,
        pid: node.data.id ? node.data.id : this.fileTreesId,
        keyword: "",
      };
      const res = await fileApi.getFileList(_data);
      let arr = [];
      if (res) {
        for (let i = 0, len = res.length; i < len; i++) {
          if (res[i].type === 1) {
            //文件夹
            if (this.checkedIdList.indexOf(res[i].id) >= 0) {
              continue;
            }

            arr.push({
              folder_name: res[i].folder_name,
              id: res[i].id,
              isLeaf: res[i].number_of_subfolders ? false : true,
            });
          }
        }
        return arr;
      }
    },
    //选中节点触发事件
    handleNodeChos(data) {
      this.moveId = data.id;
    },

    loadMoreFn(ele, fn) {
      ele.addEventListener("scroll", () => {
        const _clientH = ele.clientHeight;
        const _scrollT = ele.scrollTop;
        const _scrollH = ele.scrollHeight - 1; //(偏差量)
        // console.log(fn)
        if (_clientH + _scrollT >= _scrollH) {
          // console.log(1)
          fn();
        }
        // console.log(_clientH, _scrollT, _scrollH)
      });
    },

    //取消上传
    handleCancelUpload(item) {
      // console.log(item)
      item.source.cancel("取消上传");
      let index = this.uploadArr.findIndex((res) => res.name == item.name);
      this.uploadArr.splice(index, 1);
      if (!this.uploadArr.length) {
        this.$emit("uploading", false);
      }
    },
    beforeAvatarUpload(file) {
      let fileType = ["jpg", "jpeg", "png", "bmp", "doc", "gif", "svg", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "pdf", "txt", "mp4", "avi", "f;v", "wav", "mpeg", "mov", "dat", "mpg", "zip", "rar", "tar"];
      let arr = file.name.split(".");
      const isType = fileType.indexOf(arr[arr.length - 1].toLowerCase()) > -1;
      const isLt2M = (file.size / Math.pow(1024, 2)).toFixed(2) < 200;
      if (!isType) {
        this.$message.error("上传附件格式不对!");
      } else if (!isLt2M) {
        this.$message.error(`文件上传最高限制为200MB，请上传200MB以下的文件！`);
      }
      return Boolean(isType) && Boolean(isLt2M);
    },
    onProgress(file) {
      // console.log(file)
      if (!this.uploading) {
        //上传中，离开页面判断的参数为true 通过父组件触发离开页面判断
        this.uploading = true;
        this.$emit("uploading", true);
      }
      let idx = this.uploadArr.findIndex((res) => res.name == file.name);
      let fl = this.beforeAvatarUpload(file);
      if (!fl) {
        file.source.cancel("取消上传");
        return;
      } else if (idx > -1) {
        this.uploadArr.splice(idx, 1, file);
      } else {
        this.uploadArr.push(file);
      }
      if (file.percentage === 100) {
        this.apiData.page = 1;
        this.apiData.keyword = "";
        this.dataset.project_attachments.push(file)
        this.init();
        this.uploadArr.splice(idx, 1);
        if (!this.uploadArr.length) {
          //若没上传列表，则放开离开页面判断的参数
          this.uploading = false;
          this.$emit("uploading", false);
        }
      }
      console.log(file)
    },
    foleSelectChange({ checked, id }) {
      // 文件被选中
      this.fileList.find((res, index) => {
        if (res.id === id) {
          this.$set(this.fileList[index], "checked", checked);
          return true;
        }
      });
    },
    findFile(data) {
      // 进入文件夹
      this.allFilesCancelUpload();
      if (data && data.id) {
        this.ruleForm.pid = data.id;
        this.getFileDetail();
      }
      this.per_page = 20;
      this.page = 0;
      this.loading = false;
      this.finish = false;
      this.hasData = false;
      this.check = false;
      this.sall = false;
      this.fileList = [];
      this.uploadArr = [];
      this.load();
    },
    previewFile(item) {
      const name = item.oss_attachment_name;
      const _type = item.attachment_type;
      const _arr = ["jpg", "png", "gif", "jpeg", "tiff", "psd", "raw", "eps", "svg", "bmp", "pdf", "docx"];
      const typeVideo = ["mp4", "mpeg", "mpg", "dat", "avi", "mov", "asf", "wmv", "navi", "3gp", "mkv", "flv", "f4v", "rmvb", "webm", "hddvd", "qsv"];
      const _arr2 = _arr.concat(typeVideo);
      if (_arr2.indexOf(_type) >= 0) {
        this.getOssUrl(name, (data) => {
          this.opendImgUrl(_type, data.sign_url);
        });
      } else {
        this.$message({
          message: "该文件不支持预览，请下载后查看",
          type: "warning",
        });
      }
    },
    handleRename(item) {
      this.checkCell = item;
      this.restNameShow = true;
    },
    nameCheck(row) {
      if (row.type === 1) {
        this.handleClickFolder(row);
      } else {
        this.previewFile(row);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.file-management {
  display: flex;
  flex-direction: column;
  height: 100%;

  .num-wrap {
    display: flex;
    align-items: center;
    opacity: 0.8;
    font-size: 12px;
    color: rgba(32, 32, 32, 0.6);
    line-height: 14px;
    font-weight: 400;
    margin-right: 17px;
  }
  .btn-right {
    display: flex;
    align-items: center;
    .el-input {
      margin-right: 24px;
      width: 400px;
      line-height: 32px;
      ::v-deep {
        .el-input__icon {
          line-height: 32px !important;
        }
        .el-input__inner {
          background: #f7f8f9;
        }
      }
    }
  }
  .info-btn-box {
    display: flex;
    align-items: center;
  }
  .iconicon_help_nor {
    opacity: 0.4;
    color: rgba(32, 32, 32, 0.6);
    font-size: 16px;
  }
  .info-btn,
  .operate-wrap {
    display: flex;
    align-items: center;
    > * {
      margin-right: 24px;
    }
    &.info-btn {
      .operate-btn {
        width: 88px;
        justify-content: center;
        margin-right: 24px;
      }
      .create-btn {
        margin-right: 24px;
        margin-left: 0;
        .iconfont {
          font-size: 14px;
        }
      }
      .upload-oss {
        margin-right: 24px;
        .uploda-btn {
          background-image: linear-gradient(225deg, #269af9 0%, #0f73e9 100%);
          color: #fff;
          border-radius: 4px;
          border: none;
          &:hover {
            background-image: linear-gradient(225deg, #2fa9ff 0%, #1278eb 100%);
          }
          &:active {
            color: rgba(255, 255, 255, 0.8);
            background-image: linear-gradient(225deg, #026ed8 0%, #0155ba 100%);
          }
        }
      }
      .tooltip {
        cursor: pointer;
      }
    }
    &.operate-wrap {
      .el-checkbox {
        margin-right: 40px;
      }
      .el-button + .el-button {
        margin-left: 24px;
      }
      .el-button--small {
        width: 76px;
        height: 32px;
        padding: 0 !important;
        font-size: 14px;
        color: rgba(32, 32, 32, 0.6);
        border: 1px solid rgba(32, 32, 32, 0.16);
        &:hover {
          background: #f7f8f9;
        }
        &:active,
        &:focus {
          color: #0d1f3c;
          background: #eaebec;
        }
        &.is-disabled {
          opacity: 0.4;
          background: #fff;
          border: 1px solid rgba(32, 32, 32, 0.16);
          color: rgba(32, 32, 32, 0.6);
        }
        &.warn {
          color: #ff3939;
          border: 1px solid rgba(255, 57, 57, 0.2);
          &:hover {
            background: #fff0f0;
          }
          &:active,
          &:focus {
            color: #da2222;
            background: #ffd8d8;
          }
          &.is-disabled {
            &:hover {
              background: none;
            }
          }
        }
      }
    }
  }
  .fileManagement-header {
    padding-bottom: 32px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    .top,
    .search-wrap {
      width: 100%;
      padding: 0 40px;
      margin: 0 auto;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-shrink: 0;
      .search-wrap-right {
        display: flex;
        align-items: center;
      }
      &.top {
        margin: 24px auto;
        .breadcrumb {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          .breadcrumb-all {
            color: rgba(32, 32, 32, 0.6);
            font-size: 12px;
            margin-left: 16px;
          }
          li {
            cursor: pointer;
            display: flex;
            align-items: center;
            font-size: 16px;
            color: rgba(32, 32, 32, 0.6);
            line-height: 24px;
            font-weight: 500;
            max-width: 244px;
            p {
              max-width: 216px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            i {
              margin: 0 6px;
              color: rgba(32, 32, 32, 0.6);
            }
            &:first-child {
              &::before {
                display: none;
              }
            }
            &:hover {
              color: initial;
            }
            &:active {
              color: initial;
            }
            &:last-child {
              cursor: auto;
              color: initial;
            }
          }
          .last-bread {
            color: rgba(32, 32, 32, 0.6);
            i {
              color: rgba(32, 32, 32, 0.6);
            }
          }
        }
      }
      &.search-wrap {
        height: 34px;
        .el-input {
          width: 400px;
          line-height: 32px;
          input {
            background: #f7f8f9;
          }
        }
      }
    }
  }
  .file-wrap {
    padding: 0 13px 13px;
    box-sizing: border-box;
    overflow: auto;
    height: 100%;
    position: relative;
    .file-item-wrap {
      display: flex;
      flex-wrap: wrap;
      overflow: scroll;
      padding-bottom: 11px;
    }
  }
  .tree-dialog-wrap {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 99;
    overflow: auto;
    margin: 0;
    .tree-dialog {
      width: 590px;
      height: 420px;
      overflow: hidden;
      background: #ffffff;
      box-shadow: 0px 4px 16px 0px rgba(58, 73, 96, 0.2);
      border-radius: 8px;
      position: absolute;
      top: 120px;
      left: 50%;
      transform: translate(-50%, 0);
      display: flex;
      flex-direction: column;
      .el-tree {
        height: 0;
        flex: 1;
      }
      .tree-dialog-header {
        width: 100%;
        height: 68px;
        padding: 0 24px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .tit {
          font-size: 20px;
          color: #0d1f3c;
          line-height: 20px;
          font-weight: 500;
        }
        i {
          cursor: pointer;
          &:hover {
            color: $colorStatus-hoverColor;
          }
          &:active {
            color: $colorStatus-activeColor;
          }
        }
      }
      .btn-wrap {
        width: 100%;
        padding: 11px 24px;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        > *:first-child {
          margin-right: 16px;
        }
        button {
          width: 60px;
          height: 32px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          text-align: center;
        }
        .el-button + .el-button {
          margin-left: 24px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.file-management-dialog-tree {
  height: 420px;
  .tree {
    height: 100%;
  }
}
.file-management-dialog {
  .el-dialog__header {
    padding-bottom: 0;
    .el-dialog__title {
      font-size: 20px;
      color: #0d1f3c;
      line-height: 20px;
      font-weight: 600;
    }
  }
  .el-dialog__body {
    padding: 24px;
  }
  .el-dialog__footer {
    padding: 0 24px 24px;
    .btn-wrap {
      display: flex;
      justify-content: flex-end;
      > *:first-child {
        margin-right: 16px;
      }
      .el-button {
        width: 100px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        &.el-button--primary {
          &.is-disabled {
            background: #bebfc1 !important;
            color: rgba(32, 32, 32, 0.6);
          }
        }
      }
      .el-button + .el-button {
        margin-left: 16px;
      }
    }
  }
  textarea {
    min-height: 148px !important;
    padding: 10px 8px;
    resize: none;
    font-size: 14px;
  }
}
.file-management {
  .search-wrap {
    .el-input__icon {
      line-height: 32px;
    }
    .el-input {
      .el-input__inner {
        background: #f7f8f9;
      }
    }
  }
  .el-input--suffix .el-input__inner {
    padding-right: 8px;
  }
  .el-button--small {
    font-size: 14px;
    letter-spacing: 1px;
  }

  .el-tree {
    width: 100%;
    max-height: 296px;
    overflow: scroll;
    padding-bottom: 8px;
    box-sizing: border-box;
    border-top: 1px solid rgba(231, 232, 237, 0.6);
    border-bottom: 1px solid rgba(231, 232, 237, 0.6);
    .el-tree-node__content > .el-tree-node__expand-icon {
      padding: 6px 17px;
    }
    .el-tree-node__content:hover {
      background: rgba(32, 32, 32, 0.04);
      color: #0d1f3c;
    }
    .is-current {
      .el-tree-node__content:hover {
        background: #ebf3fd;
        color: #0073ff;
      }
    }
    .is-expanded {
      .el-tree-node__content {
        .el-tree-node__label {
          font-size: 16px;
          font-weight: 500;
        }
      }
      .el-tree-node__children {
        .el-tree-node__label {
          font-size: 14px;
          font-weight: normal;
        }
      }
    }
    .el-tree-node > .el-tree-node__children {
      overflow: visible;
    }
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: rgba(32, 32, 32, 0.6);
  }
  .el-button {
    font-weight: 400;
    &:hover {
      color: rgba(32, 32, 32, 0.6);
      background: #f7f8f9;
      border: 1px solid rgba(32, 32, 32, 0.16);
    }
    &:focus,
    &:active {
      color: #0d1f3c;
      background: #eaebec;
      border: 1px solid rgba(32, 32, 32, 0.16);
    }
    &.el-button--primary {
      &:hover {
        color: #fff;
      }
    }
  }
  .iconicon_enlarge {
    font-size: 14px;
    margin-right: 8px;
  }
  .upload-icon-box {
    display: flex;
    align-items: center;
  }
  .upload-icon {
    width: 14px;
    margin-right: 9px;
    line-height: 34px;
  }
  .is-loading {
    opacity: 0.4;
    pointer-events: none;
  }
}
</style>
